export default __webpack_public_path__ + "alberta-fab-contact-data.8d341f216cd048261ef6.svg";